import comp from "./AcademicYearsSetup";
export default comp;
